import axios from 'axios';

export default (id, payload) => {
  const jsonForm = {
    name: payload.name,
    description: payload.description,
  };

  const promise = new Promise((resolve, reject) => {
    axios
      .patch(process.env.VUE_APP_API_ADMIN_LOCATION + `providers/provider-types/${id}`, jsonForm)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
